export default function chillStoriesController() {
  const swiperEl = document.querySelector('.swiper-chill-stories');
  if (!swiperEl) return;

  const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;

  const swiper = new Swiper(swiperEl, {
    slidesPerView: 1.3,
    spaceBetween: 30,
    centeredSlides: slidesCount > 1,
    centeredSlidesBounds: true,
    loop: false,
    effect: 'slide',
    initialSlide: 1,
    breakpoints: {
      600: {
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
  });

  const videoSlides = document.querySelectorAll('.swiper-slide.video');

  videoSlides.forEach((slide) => {
    const video = slide.querySelector('video');
    const playButton = slide.querySelector('.play');
    if (!video || !playButton) return;

    slide.dataset.playing = 'false';

    video.muted = true;
    video.autoplay = false;
    video.loop = true;

    video.addEventListener('loadeddata', () => {
      try {
        video.play().then(() => {
          video.pause();
          video.currentTime = 0;
        });
      } catch (err) {
        console.warn('Autoplay preload failed:', err);
      }
    });

    video.addEventListener('loadedmetadata', () => {
      video.currentTime = 0.05; // jump off the zero-second key-frame
    });

    slide.addEventListener('click', function (e) {
      e.preventDefault();
      const isPlaying = slide.dataset.playing === 'true';

      videoSlides.forEach((otherSlide) => {
        const otherVideo = otherSlide.querySelector('video');
        const otherPlay = otherSlide.querySelector('.play');
        if (otherSlide !== slide && otherVideo) {
          otherVideo.pause();
          otherVideo.currentTime = 0;
          otherSlide.dataset.playing = 'false';
          if (otherPlay) otherPlay.style.display = 'flex';
        }
      });

      if (isPlaying) {
        video.pause();
        slide.dataset.playing = 'false';
        playButton.style.display = 'flex';
      } else {
        video.muted = false;
        video.play();
        slide.dataset.playing = 'true';
        playButton.style.display = 'none';
      }
    });
  });
}
